define([
    "jquery",
    "components/modal",
    "core/utilities",
    "core/iterate",
    "core/urls",
    "components/fake-progress",
], function (
    $,
    modal,
    utilities,
    iterate,
    urls,
    FakeProgress
) {
    var nodes = {
        addContactButton: document.querySelector(".add-contact"),
        contactsTable: document.querySelector("table.existing-contacts"),
        existingContacts: document.querySelectorAll(".existing-contacts tbody tr"),
        contactsCheckboxes: document.querySelectorAll(".existing-contacts tbody input[type=checkbox]"),
        manualContactWrap: document.querySelector(".manual-contacts .contacts-wrap"),
        checkAllContacts: document.querySelector(".check-all"),
        form: {
            firstNames: document.querySelectorAll(".manual-contacts input.first-name"),
            firstNameErrors: document.querySelectorAll(".manual-contacts .error-first-name"),
            lastNames: document.querySelectorAll(".manual-contacts input.last-name"),
            lastNameErrors: document.querySelectorAll(".manual-contacts .error-last-name"),
            emails: document.querySelectorAll(".manual-contacts input.email"),
            emailErrors: document.querySelectorAll(".manual-contacts .error-email"),
            totalFormsInput: document.querySelector('[name="form-TOTAL_FORMS"]'),
            submit: document.querySelector('.submit'),
            main: document.querySelector('form.main-form'),
        },
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".create-survey-s4"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
        loaderElement: document.querySelector(".marketing-loader"),
        loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
    };

    var createdModal = modal.create(nodes.modal, function (el) {});
    let modalTemplate = document.querySelector(".modal-template-leave_js");
    let hrefs = document.querySelectorAll("a[href]"); 
    let surveyId = document.querySelector("[data-survey-id]").dataset.surveyId;

    let isGlobal = Boolean(document.querySelector(".create-survey-s4.global"));

    let hrefsToIgnore = [
        urls['projects:start_projects_survey'](surveyId),
        urls['projects:start_projects_survey_s2'](surveyId),
        urls['projects:start_projects_survey_s3'](surveyId),
        urls['projects:start_projects_survey_s4'](surveyId),
        urls['projects:start_projects_survey_final'](surveyId),
    ];

    let loadingScreen = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );

    function exitWarningGeneric() {
        iterate(hrefs, function (node) {
            node.addEventListener("click", (event) => {
                utilities.confirmPageExit(
                    event,
                    createdModal,
                    modalTemplate,
                    null,
                    hrefsToIgnore
                );
            });
        });
    }

    let validationConfigs = [];

    let buildValidationConfigs = () => {
        // rebuilds configs each time it is called to capture all manual contact inputs user has generated
        nodes.form.firstNames = document.querySelectorAll(".manual-contacts input.first-name");
        nodes.form.firstNameErrors = document.querySelectorAll(".manual-contacts .error-first-name");
        nodes.form.lastNames = document.querySelectorAll(".manual-contacts input.last-name");
        nodes.form.lastNameErrors = document.querySelectorAll(".manual-contacts .error-last-name");
        nodes.form.emails = document.querySelectorAll(".manual-contacts input.email");
        nodes.form.emailErrors = document.querySelectorAll(".manual-contacts .error-email");

        validationConfigs = [];

        nodes.form.firstNames.forEach((node, i) => {
            validationConfigs.push({
                input: nodes.form.firstNames[i],
                errorNode: nodes.form.firstNameErrors[i],
                validations: ["alphaNumeric", "hasValue"],
            })
        })
    
        nodes.form.lastNames.forEach((node, i) => {
            validationConfigs.push({
                input: nodes.form.lastNames[i],
                errorNode: nodes.form.lastNameErrors[i],
                validations: ["alphaNumeric", "hasValue"],
            })
        })
    
        nodes.form.emails.forEach((node, i) => {
            validationConfigs.push({
                input: nodes.form.emails[i],
                errorNode: nodes.form.emailErrors[i],
                validations: ["email", "hasValue"],
            })
        })
    }

    let onSave = () => {
        // hide contacts table errors if any
        let tableErrorNode = document.querySelector(".error-contacts-table");
        if(tableErrorNode) tableErrorNode.classList.add("hide");

        let contactRows = document.querySelectorAll(".contacts-wrap .contact");
        let existingContacts = document.querySelector(".existing-contacts");

        let checkForSelectedContact = () => {
            let hasSelectedContact = false;
            let contactCheckboxes = existingContacts.querySelectorAll("tbody .checkbox-wrap input");
            contactCheckboxes.forEach(checkbox => {
                if(checkbox.checked) {
                    hasSelectedContact = true;
                }
            });
            return hasSelectedContact;
        }
        
        // Don't validate manual contacts if there is only one empty row (default)
        // unless there are no existing contacts found!
        // OR if there are existing contacts - at least one must be selected
        if(Boolean(existingContacts) === true) {
            if (
                contactRows.length === 1 &&
                contactRows[0].querySelector(".first-name").value === '' &&
                contactRows[0].querySelector(".last-name").value === '' &&
                contactRows[0].querySelector(".email").value === ''
            ) {
                let hasSelectedContact = checkForSelectedContact();
                if(hasSelectedContact) {
                    return true;
                } else {
                    tableErrorNode.classList.remove("hide");
                    return false;
                }
            }

            // make sure at least one contact is selected if manual contact row has been removed
            let hasSelectedContact = checkForSelectedContact();
            if (existingContacts && !contactRows.length && !hasSelectedContact) {
                tableErrorNode.classList.remove("hide");
                return false;
            }
        };

        buildValidationConfigs();
        let formIsValid = utilities.validateForm(validationConfigs);

        if(formIsValid) {
            return true;
        }

        return false;
    }

    let createEventListeners = () => {
        nodes.addContactButton.addEventListener("click", (e) => {
            e.preventDefault();

            buildValidationConfigs();

            let formIsValid = utilities.validateForm(validationConfigs);

            if(formIsValid) {
                let formNumber = nodes.form.totalFormsInput.value;
                let newRow = `
                    <div class="contact">
                        <input type="hidden" name="form-${formNumber}-active" value="true" class="active">
                        <div class="field-wrap">
                            <input class="first-name" placeholder="First Name" name="form-${formNumber}-first_name">
                            <div class="error input-error hide error-first-name"></div>
                        </div>
                        <div class="field-wrap">
                            <input class="last-name" placeholder="Last Name" name="form-${formNumber}-last_name">
                            <div class="error input-error hide error-last-name"></div>
                        </div>
                        <div class="field-wrap">
                            <input class="email" placeholder="Email" name="form-${formNumber}-email">
                            <div class="error input-error hide error-email"></div>
                        </div>
                        <div class="remove glyphicons glyphicons-remove-sign"></div>
                    </div>`;
            
                nodes.manualContactWrap.insertAdjacentHTML("beforeend", newRow);
                nodes.form.totalFormsInput.value = parseInt(nodes.form.totalFormsInput.value) + 1;

                let hiddenRemoveIcons = document.querySelectorAll(".glyphicons-remove-sign.hide");
                hiddenRemoveIcons.forEach(icon => {
                    icon.classList.remove("hide");
                })

            }
        });

        if(nodes.checkAllContacts) {
            let checkedBoxes = 0;

            nodes.checkAllContacts.addEventListener("change", (e) => {
                nodes.contactsCheckboxes.forEach(box => {
                    box.checked = e.target.checked;
                })

                if (e.target.checked) {
                    checkedBoxes = nodes.contactsCheckboxes.length;
                } else {
                    checkedBoxes = 0;
                }
            })

            nodes.contactsCheckboxes.forEach(checkbox => {
                if(checkbox.checked) checkedBoxes ++;

                checkbox.addEventListener("change", () => {
                    if(checkbox.checked) {
                        checkedBoxes ++;
                    } else {
                        checkedBoxes --;
                    }

                    if (checkedBoxes === nodes.contactsCheckboxes.length) {
                        nodes.checkAllContacts.checked = true;
                    } else {
                        nodes.checkAllContacts.checked = false;
                    }
                })
            })

            if (checkedBoxes === nodes.contactsCheckboxes.length) {
                nodes.checkAllContacts.checked = true;
            } else {
                nodes.checkAllContacts.checked = false;
            }
            
        }

        // using event delegation for remove buttons as they are generated dynamically
        nodes.manualContactWrap.addEventListener("click", event => {
            // only target remove buttons
            if(!event.target.classList.contains("remove")) return;
            // remove question element
            event.target.parentElement.remove();
            // update total questions value
            nodes.form.totalFormsInput.value = parseInt(nodes.form.totalFormsInput.value) - 1;            
            let manualContactsStartingIndex = nodes.existingContacts.length || 0;

            // loop through manual contacts and update input names
            let contacts = nodes.manualContactWrap.querySelectorAll(".contact");
            contacts.forEach((contact, i) => {
                let firstName = contact.querySelector("input.first-name");
                let lastName = contact.querySelector("input.last-name");
                let email = contact.querySelector("input.email");
                let active = contact.querySelector("input.active");

                firstName.name = `form-${manualContactsStartingIndex + i}-first_name`;
                lastName.name = `form-${manualContactsStartingIndex + i}-last_name`;
                email.name = `form-${manualContactsStartingIndex + i}-email`;
                active.name = `form-${manualContactsStartingIndex + i}-active`;
            })

            if(contacts.length === 1) {
                // hide remove contact button if only one input is present
                document.querySelector(".glyphicons-remove-sign").classList.add("hide");
            }
        })

        nodes.form.submit.addEventListener("click", (event) => {
            event.preventDefault();

            let validateSave = onSave();
            
            if(validateSave) {
                nodes.form.main.submit();
            }
        });
    }

    return {
        init: function () {
            if(!isGlobal) {
                createEventListeners();
            }
            
            exitWarningGeneric();
        },
    };
});